import React from 'react';
import { Button, Tooltip } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const CONTEXT_STORAGE_KEY = 'bot-activity-context-panel';

export function loadContextPanelOpen() {
  try {
    return localStorage.getItem(CONTEXT_STORAGE_KEY) === 'open';
  } catch {
    return false;
  }
}

export function saveContextPanelOpen(open) {
  try {
    localStorage.setItem(CONTEXT_STORAGE_KEY, open ? 'open' : 'closed');
  } catch {
    /* ignore */
  }
}

export default function MessengerLayout({
  sidebar,
  mainHeader,
  main,
  contextPanel,
  contextOpen,
  contextEnabled,
  onToggleContext,
}) {
  const showContext = Boolean(contextEnabled && contextPanel);

  return (
    <div className={`bam-root${contextOpen && showContext ? '' : ' bam-root--context-closed'}`}>
      <aside className="bam-sidebar">{sidebar}</aside>
      <main className="bam-main">
        <div className="bam-main-header wsm-pane-header">
          <div className="bam-main-header-inner">{mainHeader}</div>
          {showContext && (
            <Tooltip title={contextOpen ? 'Hide details' : 'Show details'}>
              <Button
                type="text"
                icon={contextOpen ? <RightOutlined /> : <LeftOutlined />}
                onClick={onToggleContext}
                aria-label="Toggle details panel"
              />
            </Tooltip>
          )}
        </div>
        <div className="bam-main-scroll">{main}</div>
      </main>
      {showContext && (
        <aside className="bam-context" aria-hidden={!contextOpen}>
          <div className="bam-context-panel">{contextPanel}</div>
        </aside>
      )}
    </div>
  );
}
